import { __UNSAFE_getMutableStreamingState } from './ui-streaming-state';

export const ROW_RENDER_DELAY_MS = 700;

export class StreamingStateManager {
  private fieldsSeen = new Set<string>();
  private state = __UNSAFE_getMutableStreamingState();

  setEntryIdForProcessing(entryId: string): void {
    this.state.entryIdSelectedForProcessing = entryId;
  }

  clearEntryIdForProcessing(): void {
    this.state.entryIdSelectedForProcessing = undefined;
  }

  setFieldIdForProcessing(fieldId: string): void {
    this.state.fieldIdSelectedForProcessing = fieldId;
  }

  clearFieldIdForProcessing(): void {
    setTimeout(() => {
      this.state.fieldIdSelectedForProcessing = undefined;
    }, ROW_RENDER_DELAY_MS);
  }

  markValueProcessed(fieldId: string, entryId: string): void {
    this.state.addProcessedValue(fieldId, entryId);
  }

  markFieldSeen(fieldId: string): void {
    this.fieldsSeen.add(fieldId);
    this.state.isSingleFieldStreaming = this.fieldsSeen.size === 1;
  }

  markFieldsComplete(): void {
    this.state.fieldsAreFinishedStreaming = true;
  }

  markFirstLayoutProcessed(): void {
    if (!this.state.firstLayoutProcessed) {
      this.state.firstLayoutProcessed = true;
    }
  }

  setEntryOperation(operation: 'edit' | 'delete' | undefined): void {
    this.state.currentEntryOperation = operation;
  }

  setFieldOperation(operation: 'delete' | undefined): void {
    this.state.currentFieldOperation = operation;
  }

  scheduleFieldDeletion(fieldId: string, deleteCallback: () => void): void {
    this.state.fieldIdSelectedForProcessing = fieldId;
    this.state.currentFieldOperation = 'delete';

    setTimeout(() => {
      deleteCallback();
      this.state.fieldIdSelectedForProcessing = undefined;
    }, ROW_RENDER_DELAY_MS);
  }

  scheduleEntryDeletion(entryId: string, deleteCallback: () => void): void {
    this.state.currentEntryOperation = 'delete';
    this.setEntryIdForProcessing(entryId);

    setTimeout(() => {
      deleteCallback();
      this.clearEntryIdForProcessing();
    }, ROW_RENDER_DELAY_MS);
  }

  resetOnStreamingEnd(): void {
    this.clearEntryIdForProcessing();
    this.clearFieldIdForProcessing();
    this.fieldsSeen.clear();
    setTimeout(() => {
      this.state.isSingleFieldStreaming = undefined;
    }, ROW_RENDER_DELAY_MS);
    this.state.currentFieldOperation = undefined;
    this.state.currentEntryOperation = undefined;
  }
}
